<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin correctly for Chart.js v2
Chart.plugins.register(ChartDataLabels);

export default {
  name: "school-chart-detail",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: "canvas"
    },
    type: {
      type: String,
      default: "pie" // Default to pie chart
    },
    legend: {
      type: Boolean,
      default: true // Default to pie chart
    },
    titleprop: {
      type: String,
      default: ""
    },
    query: {
      type: String,
      default: ""
    },
    search: {
      type: Object,
      default: () => {}
    },
    label: {
      type: Array,
      default: () => []
    },
    labelField: {
      type: String,
      default: null
    },
    indexField: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      chartInstance: null,
      chartData: [],
      chartLabel: [],
      chartColor: [],
      title: "",
    };
  },

  watch: {
    query() {
      this.getData();

    },
    search: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
    label(data) {
      this.chartLabel = [];
      this.chartColor = [];
      data.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    }
  },

  created() {
    this.getData();
    //
  },

  methods: {
    async getData() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/chart/query?query=${this.query}`, this.search);
        this.initChart();
        this.chartData = [];
        this.chartLabel = [];
        if(response.listPeriod1.length === 0) {
          this.title = "Không có dữ liệu";
          return;
        }
        this.chartData1 = response.listPeriod1;
        this.maxValue = Math.max(...this.chartData1) * 1.2;
        //this.chartData1 = [30, 23, 46]
        this.createChart();
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    },

    initChart() {
      this.chartLabel = [];
      this.chartColor = [];
      this.label.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    },

    createChart() {
      const ctxmark = document.getElementById(this.id).getContext("2d");

      // Destroy old chart instance before creating a new one
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctxmark, {
        type: "horizontalBar",
        data: {
          //this.chartLabel
          labels: ["Lớp 3-4t", "Lớp 4-5t", "Lớp 5-6t"],
          datasets: [
            {
              label: "Chương học       ",
              data: this.chartData1,
              backgroundColor: ["#808AC3", "#4958A9", "#162778"],
              barThickness: 15,
              //categoryPercentage: 0.5,
              //barPercentage: 0.6,
              // minBarLength: 100,
              maxBarLength: 50,
            }

          ]
        },
        options: {
          layout: {
            padding: { top: 40, bottom: 40 } // ✅ Thêm khoảng cách trên/dưới để cột vào giữa
          },
          indexAxis: "y",
          scales: {
            xAxes: [{
              ticks: {
                max: this.maxValue,
                min: 0,
                // stepSize: 20,
                display: false // ❌ Hide X-axis labels
              },
              gridLines: {
                display: false, // ❌ Hide X-axis grid lines
                drawBorder: false // ✅ Keep the X-axis line
              }
            }],
            yAxes: [{
              ticks: {
                min: 0,
                display: false // ❌ Hide Y-axis labels
              },
              gridLines: {
                display: false, // ❌ Hide Y-axis grid lines
                drawBorder: false // ✅ Keep the Y-axis line
              }
            }]
          },
          responsive: false,
          maintainAspectRatio: false,
          title: {
            display: false,
            text: this.title,
            fontSize: 20, // ✅ Correct for Chart.js v2
            fontWeight: 'bold' // Optional, some versions support this
          },
          legend: {
            display: ""
          },
          plugins: {
            datalabels: { // ✅ Show numbers on top of bars
              anchor: "end",
              align: "top",
              color: "#000",
              offset: -10, // ✅ Dịch chuyển nhãn lên trên (giảm khoảng cách)
              font: {
                //weight: "bold",
                size: 10
              },
              formatter: (value) => "           " + value, // Show the exact value
            },
          }
        }
      });
    }
  }
};
</script>
